var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 698,
    height: 141,
    viewBox: "0 0 698 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M615.672 41.7378C603.161 52.9499 591.044 63.8087 579.353 70.4999C591.044 77.1911 603.161 88.0498 615.672 99.262C638.312 119.552 662.244 141 687.283 141C688.068 141 688.849 140.987 689.628 140.961C690.407 140.987 691.19 141 691.975 141L1304.61 141C1343.49 141 1375 109.436 1375 70.5C1375 31.564 1343.49 0.000115916 1304.61 0.000109108L691.975 4.66534e-05C691.19 4.65159e-05 690.408 0.0129155 689.63 0.0384544C688.85 0.0128847 688.068 6.87734e-08 687.283 0C662.244 -2.1924e-06 638.312 21.4475 615.672 41.7378Z",
    fill: "#F2F5F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M543.328 41.7378C555.839 52.95 567.956 63.8087 579.647 70.4999C567.956 77.1911 555.839 88.0498 543.328 99.262C520.688 119.552 496.756 141 471.718 141C470.933 141 470.152 140.987 469.374 140.961C468.594 140.987 467.811 141 467.025 141L70.3887 141C31.5141 141 1.70078e-06 109.436 0 70.5001C-1.70078e-06 31.5641 31.5141 0.000215237 70.3887 0.000211833L467.025 0.000180606C467.809 0.000180537 468.59 0.0130284 469.369 0.0385255C470.148 0.0129137 470.931 7.81595e-06 471.718 7.81595e-06C496.756 7.81595e-06 520.688 21.4475 543.328 41.7378Z",
    fill: "#F2F5F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightVector);
export default __webpack_public_path__ + "static/media/rightVector.6629f16d69cae3dfc15e09c4b8512bb6.svg";
export { ForwardRef as ReactComponent };